import {createAsyncThunk} from '@reduxjs/toolkit';
import fetchRequest from './utils';

const getUserApplications = createAsyncThunk('applications/getUserApplications', async () => fetchRequest('/applications', 'GET', {addProducts: true}));

export default getUserApplications;
